import moment from 'moment-timezone';
import {  isValidPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input';
import twilioVerify from './phoneVerify';

export function toUserTimezone(dateStr, timezone) {
  const tz = timezone || 'America/Los_Angeles';
  return moment.utc(dateStr).tz(tz);
}

export function isValidPhone(text) {
  // From: https://stackoverflow.com/questions/4338267/validate-phone-number-with-javascript
  return !!text.trim().match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i);
}

export function isEmail(text) {
  if (!text) return false;
  return text.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
}

export function validateEmail(rule, value, callback) {
  if (value) {
    const match = isEmail(value);
    if (!match) {
     callback('Email address is not valid.');
    } else {
      callback();
    }
  } else {
    callback();
  }
}

export function validatePhone(rule, value, callback) {
  if (value) {
    const isValid = isValidPhoneNumber(value);
    if (isValid || value.length === 10) {
      if (rule.skipNetwork) {
        callback();
      } else {
        twilioVerify(value).then((resp) => resp ? callback() : callback('Please enter a valid phone number'));
      }
    } else {
      callback('Please enter a valid phone number');
    }
  } else {
    callback();
  }
}

export function formatPhone(number) {
  if (!number) return '';
  return formatPhoneNumberIntl(number);
}

export function getFullName(user) {
  if (user) {
    const { name,user_preferred_name, user_first_name, user_last_name } = user;
    return `${name ||user_preferred_name || user_first_name || ''} ${user_last_name || ''}`
  }
}

export function getInitials(firstname, lastname) {
  const i = firstname ? firstname[0] : '';
  const l = lastname ? lastname[0] : '';
  return (i + l).toUpperCase();
}

export const formatCurrency = (val) => {
  return Number(val).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
